import { createSlice } from '@reduxjs/toolkit';

const initialState = {
	initialized: false,
	isOnline: true,
	apiStatus: 'idle',
};

const appStatusSlice = createSlice({
	name: 'appStatus',
	initialState,
	reducers: {
		setInitialized(state, action) {
			state.initialized = action.payload;
		},
		setIsOnline(state, action) {
			state.isOnline = action.payload;
		},
		setApiStatus(state, action) {
			state.apiStatus = action.payload;
		},
	},
});

export const { setInitialized, setIsOnline, setApiStatus } = appStatusSlice.actions;
export default appStatusSlice.reducer;


